import { FC, Fragment, MouseEventHandler, ReactNode } from 'react'
import { DefaultChip } from '@omnea-app/frontend/components/shared/ui/chip/DefaultChip'
import { getRiskScoreColorSx } from '../../../../../../../../color/getRiskScoreColorSx'

type Props = {
  score: number
  possibleScores: number[]
  onClick?: MouseEventHandler
  chipLabel: string
  showAggregationMessage: boolean
  tooltip: ReactNode
  size?: 'small' | 'medium' | 'tiny'
  setTooltipOpen: (value: boolean) => void
}

export const RiskMatrixScoreMainChip: FC<Props> = ({
  score,
  possibleScores,
  chipLabel,
  onClick,
  showAggregationMessage,
  tooltip,
  size = 'medium',
  setTooltipOpen,
}) => {
  return (
    <Fragment key={score}>
      <DefaultChip
        onMouseEnter={() => setTooltipOpen(true)}
        onClick={onClick}
        label={chipLabel}
        color="neutral"
        size={size}
        sx={{
          fontWeight: 'bold',
          fontSize: size === 'medium' ? '12px' : '11px',
          width: 'fit-content',
          maxWidth: '200px',
          ...(showAggregationMessage ? { boxShadow: 'inset 0 0 0 2px white' } : {}),
          ...getRiskScoreColorSx({
            possibleScores,
            score,
            type: 'dark',
          }),
        }}
        tooltipLabel={tooltip}
        PopperProps={{
          sx: {
            '& .MuiTooltip-tooltip': {
              padding: 0,
            },
          },
        }}
      />
    </Fragment>
  )
}
